<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm2"></a></p>
<div class="ctag1">In this book I follow the convention whereby audiological deafness is spelled with a lowercase “d,” to distinguish it from Deafness with an uppercase “D,” a reference to the culture and community of those with fluency in sign language.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jenn_9781558616912_oeb_fm2_r1.vue?58748792